import React from "react";
class Documents extends React.Component {

    componentDidMount() {

    }

    render() {
        return (
          <section className="rob-documents">
              <div className="container">
                  <div className="row">

                      {this.props.documents.map(function (name, index) {
                          return <div className={'rob-documents__col col-md-3'}>
                              <a href={name.link} className={'rob-documents__image'} target={"_blank"}>
                                  <img src={name.image} alt={name.title}/>
                              </a>
                              <a href={name.link} className={'rob-documents__title'} target={"_blank"} >
                                  {name.title}
                              </a>
                          </div>
                      })
                      }

                  </div>
              </div>
          </section>
        )
    }
}

Documents.defaultProps = {accordian: []};

export default Documents;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/Documents.js